import React from 'react';
import { SVGAttributes } from 'react';

export const OrganizationWorkerIcon: React.FC<SVGAttributes<never>> = (
  props
) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.36 9.21778C14.31 9.84111 16 10.8611 16 12.2778V17H0V12.2778C0 10.8611 1.69 9.84111 3.65 9.21778L4.27 10.3889L4.5 10.8611C3 11.2956 1.9 11.9189 1.9 12.2778V15.2056H6.12L7 10.4172L6.06 8.64167C6.68 8.57555 7.33 8.52833 8 8.52833C8.67 8.52833 9.32 8.57555 9.94 8.64167L9 10.4172L9.88 15.2056H14.1V12.2778C14.1 11.9189 13 11.2956 11.5 10.8611L11.73 10.3889L12.36 9.21778ZM8 1.88889C6.9 1.88889 6 2.73889 6 3.77778C6 4.81667 6.9 5.66667 8 5.66667C9.1 5.66667 10 4.81667 10 3.77778C10 2.73889 9.1 1.88889 8 1.88889ZM8 7.55556C5.79 7.55556 4 5.865 4 3.77778C4 1.69056 5.79 0 8 0C10.21 0 12 1.69056 12 3.77778C12 5.865 10.21 7.55556 8 7.55556Z" />
    </svg>
  );
};

export default OrganizationWorkerIcon;
